/**
 * @param {Object} obj
 * @returns {Array<string>}
 */
const _getAllValues = (obj) =>
	Object.values(obj).reduce((acc, item) => {
		if (typeof item === "string") acc.push(item);
		else if (typeof item === "object" && item !== null) acc.push(..._getAllValues(item));
		return acc;
	}, []);

export const skipLinks = {
	main: "#main-content",
	search: {
		leftDrawerButton: "#open-search-left-drawer",
		rightDrawerButton: "#open-search-right-drawer",
		input: "#header-search",
	},
	productList: "#skip-category-navigation-target",
	brandList: "#skip-brand-list-target",
};

export const skipLinkHashes = _getAllValues(skipLinks);

/**
 * Auf der Suchergebnis-Seite werden – anders als auf der normalen PLS – Kategorien, Filter und Sortierung über den URL-Hash abgebildet.
 * Bsp: https://www.outletcity.com/de-de/shop/suche/?s=gelbe%20hosen&department=herren#/Kategorie/Herren%3EBekleidung/Marken/BOSS
 * Deshalb müssen wir hier das Browser-Sprungmarken-Verhalten (Id wird als Hash an die URL angehängt) unterbinden,
 * sonst funktioniert das Global SPA Focus Management in `orchestrator/src/router/utils.ts` nicht.
 *
 * @param {Event} e
 */
export const preventRouting = (e) => {
	if (!e.target?.hash || !skipLinkHashes.includes(e.target.hash)) return;

	e.preventDefault();
	const targetElement = document.querySelector(e.target.hash);
	targetElement?.scrollIntoView();
	targetElement?.focus();
};

const SKIP_LINK_SELECTOR = ".skip-link, .in-between-skip-link";

export const preventSkipLinkRouting = () => {
	document.querySelectorAll(SKIP_LINK_SELECTOR).forEach((linkEl) => {
		linkEl.addEventListener("click", preventRouting);
	});
};

export const restoreSkipLinkRouting = () => {
	document.querySelectorAll(SKIP_LINK_SELECTOR).forEach((linkEl) => {
		linkEl.removeEventListener("click", preventRouting);
	});
};
